export default "__VITE_ASSET__xzpmadfh__"